export const GET_PRODUCTS = `
query($page:ID, $q:String) {
  products(page: $page, q:$q) {
    count
    results{
      id
      name
      productTier {
        id
        name
      }
      productCategory {
        id
        name
      }
      opportunityProspect {
        id
        name
      }
    }
    errors{
      description
    }
  }
}
`

export const GET_PRODUCTS_INCLUDING_PHASED_OUT = `
query($page:ID, $q:String) {
  products(page: $page, q:$q, includeInactive: true) {
    count
    results{
      id
      name
      isActive
      productTier {
        id
        name
      }
      productCategory {
        id
        name
      }
      opportunityProspect {
        id
        name
      }
    }
    errors{
      description
    }
  }
}
`

export const SEARCH_PRODUCTS = `
query($page:ID, $q:String) {
  products(page: $page, q:$q) {
    count
    results{
      id
      name
      fundCode
      productTier {
        id
        name
      }
      productCategory {
        id
        name
      }
      opportunityProspect {
        id
        name
      }
    }
    errors{
      description
    }
  }
}
`;

export const UPDATE_PRODUCT_CATEGORY = `
  mutation UpdateProductCategory($id:ID!, $name: String!) {
    updateProductCategory(id: $id, name: $name ){
      productCategory {
        id
        name
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_PRODUCT_CATEGORIES = `
  query($page:ID!) {
    productCategories(page: $page) {
      count
      results{
        id
        name
        products {
          id
          name
        }
      }
      errors{
        description
      }
    }   
  }
`;

export const CREATE_PRODUCT = `
  mutation CreateProduct($name:String!, $opportunityProspectId:ID!, $productCategoryId:ID!,$productTierId:ID!, $fundCode:String!, $transactionFields: JSON!, $taxWaiverRequired: Boolean!, $vanCode: String, $financialInstitutionId: ID, $mainProductId: ID, $developerName: String, $developerContact: String, $costOfProperty: Float, $productFundingOption: String, $mortgageDetails: String, $specificationsOfProperty: String, $accruedBenefitDistribution: String, $accruedBenefitBalance: Float) {
   createProduct(name: $name, opportunityProspectId:$opportunityProspectId, productCategoryId:$productCategoryId, productTierId:$productTierId, fundCode:$fundCode, transactionFields:$transactionFields, taxWaiverRequired: $taxWaiverRequired, vanCode: $vanCode, financialInstitutionId: $financialInstitutionId, mainProductId: $mainProductId, developerName: $developerName, developerContact: $developerContact, costOfProperty: $costOfProperty, productFundingOption: $productFundingOption, mortgageDetails: $mortgageDetails, specificationsOfProperty: $specificationsOfProperty, accruedBenefitDistribution: $accruedBenefitDistribution, accruedBenefitBalance: $accruedBenefitBalance){
      product {
        id
        name
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_PRODUCT = `
mutation UpdateProduct($id: ID!, $name:String!, $productTierId:ID!,$opportunityProspectId:ID!, $productCategoryId:ID! $fundCode:String!, $transactionFields: JSON!, $taxWaiverRequired: Boolean!, $vanCode: String, $financialInstitutionId: ID, $syncPrice: Boolean!, $mainProductId: ID,  $developerName: String, $developerContact: String, $costOfProperty: Float, $productFundingOption: String, $mortgageDetails: String, $specificationsOfProperty: String, $accruedBenefitDistribution: String, $accruedBenefitBalance: Float) {
  updateProduct(id: $id, name: $name, productTierId: $productTierId, opportunityProspectId:$opportunityProspectId, productCategoryId:$productCategoryId, fundCode:$fundCode, transactionFields:$transactionFields, taxWaiverRequired: $taxWaiverRequired, vanCode: $vanCode, financialInstitutionId: $financialInstitutionId, syncPrice: $syncPrice, mainProductId: $mainProductId, developerName: $developerName, developerContact: $developerContact, costOfProperty: $costOfProperty, productFundingOption: $productFundingOption, mortgageDetails: $mortgageDetails, specificationsOfProperty: $specificationsOfProperty, accruedBenefitDistribution: $accruedBenefitDistribution, accruedBenefitBalance: $accruedBenefitBalance){
    product {
      id
      name
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_PRODUCT_EXTENDED = `
query GetProduct($id: String){
  product(id: $id ) {
    id
    name
    isActive
    fundCode
    transactionFields
    taxWaiverRequired
    vanCode
    developerName
    developerContact
    costOfProperty
    productFundingOption
    mortgageDetails
    specificationsOfProperty
    accruedBenefitDistribution
    financialInstitution {
      id
      name
    }
    productCategory {
      id
      name
    }
    productTemplates{
      id
      medium
      to
      template {
        id
        name
      }
    }
    productTier {
      id
      name
    }
    opportunityProspect {
      id
      name
    }
    prices {
      id
      priceDate
      amount
      isOpen
      createdAt
    }
    assetMapId
    syncPrice
    subProducts{
      id
      name
      productTier {
        id
        name
      }
      productCategory {
        id
        name
      }
      opportunityProspect {
        id
        name
      }
    }
  }
}
`;

export const DELETE_PRODUCT = `
  mutation DeleteProduct($id:ID!) {
    deleteProduct(id: $id ){
      result
      errors {
        property
        description
      }
    }
  }
`;



export const CLOSE_PRICE = `
mutation ClosePrice($priceId:ID!, $redeemedUnits: Float!) {
  closePrice(priceId: $priceId, redeemedUnits: $redeemedUnits ){
    price{
      id
      priceDate
      amount
      isOpen
    }
    errors {
      property
      description
    }
  }
}
`;

export const CREATE_EZHOME_PRODUCT_PRICE = `
  mutation createEzHomeProductPrice($productId:ID!, $priceDate: String!, $price: Float!) {
    createEzHomeProductPrice(productId: $productId, priceDate: $priceDate price: $price ){
      price{
        id
        priceDate
        amount
        isOpen
      }
      errors {
        property
        description
      }
    }
  }
`;

export const ADD_TEMPLATE_TO_PRODUCT = `
  mutation AddTemplateToProduct($productId: ID!, $templateId: ID!, $medium: String!, $to: String!) {
    addTemplateToProduct(productId: $productId, templateId: $templateId, medium: $medium, to: $to) {
      productTemplate {
        id
        medium
        to
        template {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const REMOVE_TEMPLATE_FROM_PRODUCT = `
  mutation RemoveTemplateFromProduct($id: ID!) {
    removeTemplateFromProduct(id: $id) {
      result
      errors {
        property
        description
      }
    }
  }
`;

export const GET_PRODUCT_TRANSACTION_FIELD_CHANGE_LOGS = `
  query ProductTransactionFieldChangeLogs($productId: ID!) {
    productTransactionFieldChangeLogs(productId: $productId) {
      auditItem
      createdAt
      oldValue
      newValue
      user
      action
      comment
    }
  }
`;
